import { Route } from "react-router";
import Loadable from "components/Loadable";
import { lazy } from "react";

const GlobalErrorPage = Loadable(lazy(() => import('pages/main/globalErrorPage')));
const DownloadStickerPage = Loadable(lazy(() => import('pages/main/downloadSticker')));


const InAppRoutes = <Route path='/*'>
    <Route path="*" element={<GlobalErrorPage />} />
    <Route path="qrcode-sticker/download" element={<DownloadStickerPage />} />
</Route>;

export default InAppRoutes;